var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.974 12.816H7.026v13.178h17.948zM7.026 10.81C5.907 10.81 5 11.708 5 12.815v13.18C5 27.101 5.907 28 7.026 28h17.948C26.093 28 27 27.102 27 25.994V12.816a2.016 2.016 0 0 0-2.026-2.006z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.422 26.854V11.956h2.026v14.898z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.247 6.36a1.66 1.66 0 0 0-.291 2.344c.213.27.491.457.795.557l.03.01 2.58 1.031-.418-2.949-.003-.013a1.65 1.65 0 0 0-.324-.692 1.7 1.7 0 0 0-2.37-.288M9.359 9.94A3.65 3.65 0 0 1 10 4.78a3.74 3.74 0 0 1 5.214.633c.344.436.574.928.693 1.437q.021.074.033.152l.551 3.881c.163 1.147-.99 2.038-2.074 1.604l-3.337-1.334a3.7 3.7 0 0 1-1.72-1.214",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.767 6.392c.724.581.836 1.633.249 2.35-.218.266-.5.447-.805.542l-.03.01-2.598.987.47-2.942.004-.013c.054-.243.165-.478.336-.687a1.7 1.7 0 0 1 2.374-.247m1.824 3.612a3.65 3.65 0 0 0-.55-5.17 3.74 3.74 0 0 0-5.223.543 3.65 3.65 0 0 0-.718 1.425 1 1 0 0 0-.036.151l-.62 3.872c-.183 1.143.954 2.054 2.046 1.64l3.36-1.277a3.7 3.7 0 0 0 1.74-1.184",
    clipRule: "evenodd"
  })));
};
export default SvgGift;